/* eslint-disable react/jsx-no-bind */
import React from "react";
import GridItem from "../../components/Grid/GridItem";
import GridContainer from "../../components/Grid/GridContainer";
import ActivationEmailForm from "components/ActivationEmailForm/ActivationEmailForm";

class ActivationEmail extends React.Component {
  render() {
    return (
      <GridContainer spacing={8} direction="column" justify="center" alignItems="center">
        <GridItem
          md={6}
          xs={10}
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
          }}
        >
          <ActivationEmailForm />
        </GridItem>
      </GridContainer>
    );
  }
}

export default ActivationEmail;
